import moment from 'moment';
import * as XLSX from 'xlsx';

const EXCEL_AMOUNT_FORMAT = '#,##0.###;[Red](#,##0.###);0';
const MIN_COLUMN_WIDTH = 12;
const MAX_COLUMN_WIDTH = 48;

const formatExcelDate = (value) => {
  if (!value) return '';
  const parsedDate = moment.utc(value);
  return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : `${value}`;
};

const normalizeExcelNumber = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const normalizedValue = Number(`${value}`.replace(/,/g, ''));
  return Number.isFinite(normalizedValue) ? normalizedValue : null;
};

const getExcelCellValue = (row, column, { amountFields, dateFields }) => {
  const field = column.accessor;
  const value = row?.[field];

  if (amountFields.has(field)) return normalizeExcelNumber(value);
  if (dateFields.has(field)) return formatExcelDate(value);
  return value ?? '';
};

const getColumnWidth = (header, values = []) => {
  const contentWidth = values.reduce((width, value) => Math.max(width, `${value ?? ''}`.length), `${header}`.length);
  return Math.min(MAX_COLUMN_WIDTH, Math.max(MIN_COLUMN_WIDTH, contentWidth + 2));
};

export const createAccountingReportWorkbook = ({
  reportCode,
  columns = [],
  rows = [],
  amountFields = new Set(),
  dateFields = new Set(),
}) => {
  const headers = columns.map((item) => item.header);
  const columnValues = columns.map(() => []);
  const dataRows = rows.map((row) =>
    columns.map((item, columnIndex) => {
      const value = getExcelCellValue(row, item, { amountFields, dateFields });
      columnValues[columnIndex].push(value);
      return value;
    }),
  );
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...dataRows]);

  worksheet['!cols'] = columns.map((item, index) => ({ wch: getColumnWidth(item.header, columnValues[index]) }));
  if (headers.length) {
    worksheet['!autofilter'] = {
      ref: `A1:${XLSX.utils.encode_col(headers.length - 1)}${Math.max(1, dataRows.length + 1)}`,
    };
  }

  columns.forEach((item, columnIndex) => {
    if (!amountFields.has(item.accessor)) return;

    for (let rowIndex = 1; rowIndex <= dataRows.length; rowIndex += 1) {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: columnIndex });
      const cell = worksheet[cellAddress];
      if (cell?.t === 'n') cell.z = EXCEL_AMOUNT_FORMAT;
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, `${reportCode || 'Bao cao'}`.slice(0, 31));
  return workbook;
};

export const getAccountingReportExcelFileName = (reportCode, exportedAt = moment()) =>
  `${reportCode}_${exportedAt.format('YYYYMMDD_HHmm')}.xlsx`;
